export * from './window.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/window/index.ts